/**
 * 枚举
 * Created by JiangChuanqi on 2017/8/14.
 */

/** 通过key寻找枚举 */
export const findByKey = (enumSet, key) => {
  if(!key) {
    return {}
  }
  let _enum = toList(enumSet).find(e => (e.key == key || e.value == key));
  return _enum ? _enum : {};
};

/** 转成列表 */
export const toList = enumSet => {
  let list = [];
  Object.keys(enumSet).forEach(function(key) {
    list.push(enumSet[key]);
  });
  return list;
};

//申请状态
export const APPLY_STATUS = {
  TEMP_STORAGE: { key: 'TEMP_STORAGE', value: '暂存', tagType:'info', color:'#e6a23c'},
  WAITING: { key: 'WAITING', value: '审核中', tagType:'warning', color:'#e6a23c'},
  TURNDOWN: { key: 'TURNDOWN', value: '已退回', tagType:'danger', color:'#eb5050' },
  REJECT: { key: 'REJECT', value: '已拒绝', tagType:'danger', color:'#eb5050' },
  PASS: { key: 'PASS', value: '审核中', tagType:'warning', color:'#e6a23c' },
  EXPERT_REVIEW: { key: 'EXPERT_REVIEW', value: '审核中', tagType:'warning', color:'#e6a23c'},
  BG_REVIEW: { key: 'BG_REVIEW', value: '审核中', tagType:'warning', color:'#e6a23c'},
  FINISH_PASS: { key: 'FINISH_PASS', value: '已通过', tagType:'success', color:'#13ce66' },
  TERMINATION: { key: 'TERMINATION', value: '项目中止', tagType:'danger', color:'#eb5050' },
}

//证件类别
export const CARD_TYPE = {
  ID_CARD:{label:'居民身份证', value:'0'},
  HK_CARD:{label:'港澳台证件', value:'1'},
  FOREIGN:{label:'外籍', value:'2'},
}

//婚姻状况
export const MARITAL_STATUS = {
  UNMARRIED:{label:'未婚', value:'0'},
  MARRIED:{label:'已婚', value:'1'},
  DIVORCE:{label:'离异', value:'2'},
  BEREAVE:{label:'丧偶', value:'3'},
}

//社保/个税
export const SOCIAL_SECURITY_TYPE = {
  SOCIAL_SECURITY:{label:'社保', value:'socialSecurity'},
  PERSONAL_TAX:{label:'个税', value:'personalTax'},
}

//最高学历
export const HIGHEST_EDUCATION = {
  JUNIOR_COLLEGE:{label:'专科', value:'0'},
  UNDERGRADUATE:{label:'本科', value:'1'},
  MASTER:{label:'硕士', value:'2'},
  DOCTOR:{label:'博士及以上', value:'3'},
}

//单位所类型属
export const UNIT_AREA_TYPE = {
  CITY:{label:'市属', value:'city'},
  AREA:{label:'区属', value:'area'},
  OTHER:{label:'其他地区', value:'other'},
}

//子女关系
export const RELATION = {
  SON:{label:'儿子', value:'儿子'},
  DAUGHTER:{label:'女儿', value:'女儿'},
}

//户型
export const HOUSE_TYPE = {
  TWO_ROOMS:{label:'二居室', value:'0'},
  THREE_ROOMS:{label:'三居室', value:'1'},
}


//杭州区域数据
export const HZ_AREA_DATA = [
  {label:'上城区', value:'上城区'}, {label:'拱墅区', value:'拱墅区'}, {label:'西湖区', value:'西湖区'}, {label:'滨江区', value:'滨江区'},
  {label:'萧山区', value:'萧山区'}, {label:'余杭区', value:'余杭区'}, {label:'富阳区', value:'富阳区'}, {label:'临安区', value:'临安区'},
  {label:'临平区', value:'临平区'}, {label:'钱塘区', value:'钱塘区'}, {label:'桐庐县', value:'桐庐县'}, {label:'淳安县', value:'淳安县'},
  {label:'建德市', value:'建德市'}
]

//是或否
export const YES_OR_NO = {
  YES:{label:'是', value:'1'},
  NO:{label:'否', value:'0'},
}

//性别
export const SEX_TYPE = {
  MALE:{label:'男', value:'1'},
  FEMALE:{label:'女', value:'0'},
}

//项目所属产业类别
export const CYLB_TYPE = {
  LSNY:{label:'绿色能源', value:'0'},
  RJJGDXXZZ:{label:'软件及高端信息制造', value:'1'},
  SWYY:{label:'生物医药', value:'2'},
  XDFWY:{label:'现代服务业', value:'3'},
  ZBZZ:{label:'装备制造', value:'4'},
  OTHER:{label:'其它', value:'other'},
}

//项目实施方式
export const SSFS_TYPE = {
  XJQY:{label:'新建企业', value:'0'},
  XJYFJG:{label:'新建研发机构', value:'1'},
  QYGB:{label:'企业并购', value:'2'},
  JSRG:{label:'技术入股', value:'3'},
  HZKF:{label:'合作开发', value:'4'},
  OTHER:{label:'其它', value:'other'},
}

//项目技术水平
export const JSSP_TYPE = {
  GJLX:{label:'国际领先', value:'0'},
  TBGJKB:{label:'填补国际空白', value:'1'},
  GNLX:{label:'国内领先', value:'2'},
  TBGNKB:{label:'填补国内空白', value:'3'},
}

